(() => {
  'use strict';
  if (window.DevialetScrollExplode) { window.DevialetScrollExplode.boot(document); return; }
  const controllers = new Map();
  const clamp = (n, low, high) => Math.max(low, Math.min(high, n));
  const frameAt = p => p <= .2 ? p / .2 * 35 : p <= .8 ? 35 + (p - .2) / .6 * 25 : 60 + (p - .8) / .2 * 14;
  function create(root) {
    const image = root.querySelector('[data-dm-explode-image]');
    const stage = root.querySelector('[data-dm-explode-stage]');
    const media = root.querySelector('[data-dm-explode-media]');
    const phases = [...root.querySelectorAll('[data-dm-explode-phase]')];
    let frames;
    try {
      const mobileFrames = root.querySelector('[data-dm-explode-mobile-frames]');
      const selected = innerWidth < 750 && mobileFrames ? mobileFrames : root.querySelector('[data-dm-explode-frames]');
      frames = JSON.parse(selected.textContent).map(url => new URL(url,document.baseURI).href);
    }
    catch { return null; }
    if (!image || !stage || !media || frames.length !== 75) return null;
    const poster = image.src, fallback = new URL(root.dataset.dmExplodeFallback,document.baseURI).href;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const canvas = document.createElement('canvas');
    canvas.className = 'dm-explode__canvas'; canvas.setAttribute('aria-hidden','true');
    const context = canvas.getContext('2d',{alpha:false});
    const raw = new Map(), decoded = new Map(), fetching = new Set(), decoding = new Set(), failed = new Set();
    const abort = new AbortController(), bitmapSupported = typeof createImageBitmap === 'function';
    // Resize once at decode time; retain recently used frames for reversals.
    // 32 mobile bitmaps at 640×360 use 28 MB; desktop 960×540 uses 63 MB.
    const mobile = innerWidth < 750, decodeWidth = mobile ? 640 : 960, decodeHeight = decodeWidth * 9 / 16;
    const cacheLimit = bitmapSupported ? 32 : (mobile ? 10 : 18);
    const lookAhead = bitmapSupported ? 12 : (mobile ? 4 : 8);
    canvas.width = decodeWidth; canvas.height = decodeHeight;
    let nearObserver, activeObserver, geometryObserver;
    let near = false, active = false, destroyed = false, stopped = false, motion = false;
    let desired = 0, target = 0, smoothed = 0, rendered = 74, direction = 1, phase = -1;
    let workers = 0, encodedBytes = 0, raf = 0, dirty = true, measure = true, lastTime = 0;
    let stickyTop = 0, range = 1, reducedState = reduced.matches, fallbackAttempted = false;
    let hasGoodImage = image.complete && image.naturalWidth > 0;
    const running = () => !destroyed && !stopped && !reduced.matches && !document.hidden && near;
    const stats = () => {
      const values = {Loaded:raw.size,Decoded:decoded.size,Workers:workers,Bytes:encodedBytes,Desired:desired,Active:active,Suspended:document.hidden};
      for (const [key,value] of Object.entries(values)) {
        const name = 'dmExplode' + key, text = String(value);
        if (root.dataset[name] !== text) root.dataset[name] = text;
      }
    };
    const showPhases = index => {
      if (phase === index) return;
      phase = index;
      phases.forEach((item,i) => { const selected = index === null || i === index; item.hidden = !selected; item.classList.toggle('is-active',selected); });
    };
    const phaseAt = index => index < 35 ? 0 : index < 60 ? 1 : 2;
    const release = entry => { if (entry.bitmap) entry.bitmap.close(); else { entry.image.src = ''; URL.revokeObjectURL(entry.url); } };
    const clearDecoded = () => { for (const entry of decoded.values()) release(entry); decoded.clear(); };
    const keepRadius = () => Math.max(3,Math.floor((cacheLimit - 4) / 2));
    const trim = () => {
      if (decoded.size <= cacheLimit) return;
      const candidates = [...decoded.keys()].filter(i => i !== rendered && i !== desired).sort((a,b) => Math.abs(b - desired) - Math.abs(a - desired));
      while (decoded.size > cacheLimit && candidates.length) { const index = candidates.shift(); release(decoded.get(index)); decoded.delete(index); }
    };
    const cancelTick = () => { if (raf) cancelAnimationFrame(raf); raf = 0; lastTime = 0; };
    const removeMotion = mode => { motion = false; cancelTick(); root.classList.remove('is-motion','is-canvas'); root.dataset.dmExplodeMode = mode; showPhases(null); };
    const readableFallback = reason => {
      if (destroyed || stopped) return;
      stopped = true; abort.abort(); nearObserver?.disconnect(); activeObserver?.disconnect(); near = false; active = false;
      removeMotion('fallback'); root.dataset.dmExplodeFailure = reason; clearDecoded();
      if (!hasGoodImage && !fallbackAttempted) {
        fallbackAttempted = true; image.src = fallback; image.alt = 'Devialet Mania — adaptação acústica';
        root.dataset.dmExplodeFrame = 'fallback'; root.dataset.dmExplodeSource = fallback;
      }
      stats();
    };
    const loaded = () => { hasGoodImage = image.naturalWidth > 0; root.classList.toggle('has-no-image',!hasGoodImage); };
    const imageError = () => { hasGoodImage = false; if (fallbackAttempted) root.classList.add('has-no-image'); else readableFallback('poster-image-failed'); };
    image.addEventListener('load',loaded); image.addEventListener('error',imageError);
    const draw = index => {
      const entry = decoded.get(index);
      if (!entry || rendered === index && root.classList.contains('is-canvas')) return;
      context.drawImage(entry.bitmap || entry.image,0,0,canvas.width,canvas.height); rendered = index;
      root.classList.add('is-canvas'); root.dataset.dmExplodeFrame = String(index); root.dataset.dmExplodeSource = frames[index]; showPhases(phaseAt(index));
    };
    function schedule() { if (!raf && motion && active && running()) raf = requestAnimationFrame(tick); }
    function tick(time) {
      raf = 0; syncPreference();
      if (!motion || !active || !running()) { lastTime = 0; return; }
      if (dirty) {
        // Read geometry before frame/caption writes; cache sticky sizing until resize.
        if (measure) { stickyTop = parseFloat(getComputedStyle(stage).top) || 0; range = Math.max(1,root.offsetHeight - stage.offsetHeight); measure = false; }
        const progress = clamp((stickyTop - root.getBoundingClientRect().top) / range,0,1), next = frameAt(progress);
        if (next !== target) direction = next > target ? 1 : -1;
        target = next; desired = Math.round(target); dirty = false; root.dataset.dmExplodeProgress = progress.toFixed(4);
      }
      const delta = lastTime ? Math.min(50,time - lastTime) : 16.7; lastTime = time;
      // Short time-based easing absorbs wheel/touch steps without image load callbacks.
      smoothed += (target - smoothed) * (1 - Math.exp(-delta / 35));
      if (Math.abs(target - smoothed) < .08) smoothed = target;
      const wanted = clamp(Math.round(smoothed),0,74);
      let index = wanted;
      if (!decoded.has(index)) { let distance = Infinity; for (const available of decoded.keys()) { const d = Math.abs(available - wanted); if (d < distance) { index = available; distance = d; } } }
      if (decoded.has(index)) draw(index);
      pump(); stats();
      if (smoothed !== target) schedule(); else lastTime = 0;
    }
    const priority = () => {
      const list = [desired];
      for (let distance = 1; distance <= lookAhead; distance++) list.push(desired + distance * direction,desired - distance * direction);
      return list.filter(i => i >= 0 && i < 75);
    };
    const nextJob = () => {
      if (!running()) return null;
      if (!decoded.has(desired) && !failed.has(desired) && !fetching.has(desired) && !decoding.has(desired))
        return {index:desired,type:raw.has(desired) ? 'decode' : 'fetch'};
      // Load poses across the whole action first. A fast first scroll can then
      // advance through real nearby poses while the intervening frames arrive.
      for (let index = 0; index < 75; index += 6) {
        if (!raw.has(index) && !failed.has(index) && !fetching.has(index)) return {index,type:'fetch'};
      }
      for (const index of priority()) {
        if (!decoded.has(index) && !failed.has(index) && !fetching.has(index) && !decoding.has(index)) return {index,type:raw.has(index) ? 'decode' : 'fetch'};
      }
      // Prefetch compressed bytes before entry; retain only a bounded decoded window.
      for (let index = 0; index < 75; index++) if (!raw.has(index) && !failed.has(index) && !fetching.has(index)) return {index,type:'fetch'};
      return null;
    };
    async function fetchFrame(index) {
      fetching.add(index); const requestAbort = new AbortController(), cancel = () => requestAbort.abort();
      abort.signal.addEventListener('abort',cancel,{once:true}); const timeout = setTimeout(cancel,10000);
      try {
        const response = await fetch(frames[index],{signal:requestAbort.signal,credentials:'omit',cache:'force-cache',headers:{Accept:'image/webp,image/*;q=0.8'}});
        if (!response.ok) throw new Error('Frame HTTP ' + response.status);
        const blob = await response.blob(); if (!destroyed && !stopped) { raw.set(index,blob); encodedBytes += blob.size; }
      } finally { clearTimeout(timeout); abort.signal.removeEventListener('abort',cancel); fetching.delete(index); }
    }
    async function decodeFrame(index) {
      if (!running() || !raw.has(index) || decoded.has(index) || decoding.has(index) || Math.abs(index - desired) > lookAhead) return;
      decoding.add(index); let entry, stored = false;
      try {
        if (bitmapSupported) entry = {bitmap:await createImageBitmap(raw.get(index),{resizeWidth:decodeWidth,resizeHeight:decodeHeight,resizeQuality:'medium'})};
        else { const candidate = new Image(), url = URL.createObjectURL(raw.get(index)); entry = {image:candidate,url}; candidate.decoding = 'async'; candidate.src = url; await candidate.decode(); }
        if (!running() || Math.abs(index - desired) > keepRadius()) return;
        decoded.set(index,entry); stored = true; trim();
      } finally { decoding.delete(index); if (entry && !stored) release(entry); }
    }
    function enableMotion() {
      if (motion || !running() || !decoded.has(0)) return;
      motion = true; root.classList.add('is-motion'); root.dataset.dmExplodeMode = 'sequence'; media.appendChild(canvas); draw(0);
      dirty = true; measure = true; schedule();
    }
    function pump() {
      syncPreference();
      while (workers < 4) {
        const job = nextJob(); if (!job) break; workers++;
        (async () => { if (job.type === 'fetch') await fetchFrame(job.index); await decodeFrame(job.index); })()
          .catch(error => { if (destroyed || stopped || error.name === 'AbortError') return; failed.add(job.index); if (job.index === desired || failed.size >= 3) readableFallback(error.message || 'frame-load-failed'); })
          .finally(() => { workers--; if (destroyed) { stats(); return; } enableMotion(); schedule(); stats(); pump(); });
      }
    }
    const onScroll = () => { syncPreference(); dirty = true; schedule(); };
    const onResize = () => { syncPreference(); dirty = true; measure = true; schedule(); };
    const onVisibility = () => { syncPreference(); dirty = true; if (document.hidden) cancelTick(); else { pump(); enableMotion(); schedule(); } stats(); };
    function observe() {
      nearObserver?.disconnect(); activeObserver?.disconnect(); if (destroyed || stopped || reduced.matches) return;
      nearObserver = new IntersectionObserver(entries => { near = entries[0].isIntersecting; if (near) { pump(); enableMotion(); } else if (!active) { cancelTick(); clearDecoded(); } stats(); },{rootMargin:'3500px 0px',threshold:0});
      activeObserver = new IntersectionObserver(entries => { active = entries[0].isIntersecting; if (active) { dirty = true; measure = true; pump(); enableMotion(); schedule(); } else cancelTick(); stats(); },{threshold:0});
      nearObserver.observe(root); activeObserver.observe(root);
    }
    function onPreference() {
      reducedState = reduced.matches;
      if (reducedState) {
        nearObserver?.disconnect(); activeObserver?.disconnect(); near = false; active = false; removeMotion('reduced'); clearDecoded(); rendered = 74;
        image.src = poster; root.dataset.dmExplodeFrame = '74'; root.dataset.dmExplodeSource = poster;
      } else if (!stopped && !unsupported) { desired = 0; target = 0; smoothed = 0; dirty = true; measure = true; root.dataset.dmExplodeMode = 'poster'; observe(); }
      stats();
    }
    function syncPreference() { if (!destroyed && reducedState !== reduced.matches) onPreference(); }
    const unsupported = !context || typeof fetch !== 'function' || !('IntersectionObserver' in window);
    root.dataset.dmExplodeMode = reduced.matches || unsupported ? 'reduced' : 'poster'; root.dataset.dmExplodeSource = poster;
    root.dataset.dmExplodeRenderer = bitmapSupported ? 'bitmap-canvas' : 'image-canvas'; stats();
    if (!unsupported) {
      window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',onResize,{passive:true}); document.addEventListener('visibilitychange',onVisibility);
      if ('ResizeObserver' in window) { geometryObserver = new ResizeObserver(onResize); geometryObserver.observe(stage); }
      if (!reduced.matches) observe();
    }
    if (reduced.addEventListener) reduced.addEventListener('change',onPreference); else reduced.addListener(onPreference);
    if (image.complete && !image.naturalWidth) imageError();
    return {destroy() {
      destroyed = true; abort.abort(); cancelTick(); nearObserver?.disconnect(); activeObserver?.disconnect(); geometryObserver?.disconnect();
      window.removeEventListener('scroll',onScroll); window.removeEventListener('resize',onResize); document.removeEventListener('visibilitychange',onVisibility);
      if (reduced.removeEventListener) reduced.removeEventListener('change',onPreference); else reduced.removeListener(onPreference);
      image.removeEventListener('load',loaded); image.removeEventListener('error',imageError);
      clearDecoded(); raw.clear(); canvas.remove(); canvas.width = canvas.height = 0; active = false; near = false; encodedBytes = 0; removeMotion('unloaded'); stats();
    }};
  }
  const boot = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-dm-explode]')]; if (scope.matches?.('[data-dm-explode]')) roots.unshift(scope);
    for (const root of roots) { if (controllers.has(root)) continue; const controller = create(root); if (controller) controllers.set(root,controller); }
  };
  window.DevialetScrollExplode = {boot};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => boot(),{once:true}); else boot();
  document.addEventListener('shopify:section:load',event => boot(event.target));
  document.addEventListener('shopify:section:unload',event => { for (const [root,controller] of controllers) if (event.target === root || event.target.contains(root)) { controller.destroy(); controllers.delete(root); } });
})();
